import UserIsBlockedModalComponent from "./UserIsBlockedModalComponent";

export default UserIsBlockedModalComponent;
